import * as Yup from 'yup';

export const buildSuperMatchContactRequestFormInitialValues = () => {
  return {
    contactRequestDeadline: '',
  };
};

export const buildSuperMatchContactRequestFormValidationSchema = () => {
  return Yup.object().shape({
    contactRequestDeadline: Yup.string().required(),
  });
};
